import { toast } from 'react-toastify';
/*
import { SubmissionError } from 'redux-form'
*/
import { isFunction } from 'lodash';
import Api from 'lib/api';

const api = Api.getInstance();

const ns = 'app/partnerships/';

export const LOAD_START = ns + 'LOAD_START';
export const LOAD_SUCCESS = ns + 'LOAD_SUCCESS';
export const LOAD_FAILURE = ns + 'LOAD_FAILURE';

export const VIEW_START = ns + 'VIEW_START';
export const VIEW_SUCCESS = ns + 'VIEW_SUCCESS';
export const VIEW_FAILURE = ns + 'VIEW_FAILURE';

export const DELETE_START = ns + 'DELETE_START';
export const DELETE_SUCCESS = ns + 'DELETE_SUCCESS';
export const DELETE_FAILURE = ns + 'DELETE_FAILURE';

export const ACCEPT_START = ns + 'ACCEPT_START';
export const ACCEPT_SUCCESS = ns + 'ACCEPT_SUCCESS';
export const ACCEPT_FAILURE = ns + 'ACCEPT_FAILURE';

export const REJECT_START = ns + 'REJECT_START';
export const REJECT_SUCCESS = ns + 'REJECT_SUCCESS';
export const REJECT_FAILURE = ns + 'REJECT_FAILURE';

export const AGREE_START = ns + 'AGREE_START';
export const AGREE_SUCCESS = ns + 'AGREE_SUCCESS';
export const AGREE_FAILURE = ns + 'AGREE_FAILURE';

export const DISAGREE_START = ns + 'DISAGREE_START';
export const DISAGREE_SUCCESS = ns + 'DISAGREE_SUCCESS';
export const DISAGREE_FAILURE = ns + 'DISAGREE_FAILURE';

export const REPLY_START = ns + 'REPLY_START';
export const REPLY_SUCCESS = ns + 'REPLY_SUCCESS';
export const REPLY_FAILURE = ns + 'REPLY_FAILURE';

export const SEND_PAYMENT_START = ns + 'SEND_PAYMENT_START';
export const SEND_PAYMENT_SUCCESS = ns + 'SEND_PAYMENT_SUCCESS';
export const SEND_PAYMENT_FAILURE = ns + 'SEND_PAYMENT_FAILURE';

export const RCV_PAYMENT_START = ns + 'RCV_PAYMENT_START';
export const RCV_PAYMENT_SUCCESS = ns + 'RCV_PAYMENT_SUCCESS';
export const RCV_PAYMENT_FAILURE = ns + 'RCV_PAYMENT_FAILURE';

export const ADD_POST_START = ns + 'ADD_POST_START';
export const ADD_POST_SUCCESS = ns + 'ADD_POST_SUCCESS';
export const ADD_POST_FAILURE = ns + 'ADD_POST_FAILURE';

export const MARK_COMPLETE_START = ns + 'MARK_COMPLETE_START';
export const MARK_COMPLETE_SUCCESS = ns + 'MARK_COMPLETE_SUCCESS';
export const MARK_COMPLETE_FAILURE = ns + 'MARK_COMPLETE_FAILURE';

export const REACTIVATE_START = ns + 'REACTIVATE_START';
export const REACTIVATE_SUCCESS = ns + 'REACTIVATE_SUCCESS';
export const REACTIVATE_FAILURE = ns + 'REACTIVATE_FAILURE';

export const FULFILL_START = ns + 'FULFILL_START';
export const FULFILL_SUCCESS = ns + 'FULFILL_SUCCESS';
export const FULFILL_FAILURE = ns + 'FULFILL_FAILURE';

export const COUNTS_LOADED = ns + 'COUNTS_LOADED';

export function load(queryData) {
  return async dispatch => {
    dispatch({
      type: LOAD_START
    });

    try {
      const response = await api.get('partnerships', { params: queryData });
      const { data } = response;

      dispatch({
        type: LOAD_SUCCESS,
        payload: data
      });
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: LOAD_FAILURE,
        payload: response
      });
    }
  };
}

export function getCounts() {
  return async dispatch => {
    try {
      const response = await api.get('partnerships/counts');

      const { data } = response;

      dispatch({
        type: COUNTS_LOADED,
        payload: data.counts || null
      });
    } catch (error) {
      console.error('Unable to get counts for partnerships');
    }
  };
}

export function deletePartnership(p, callback) {
  return async dispatch => {
    dispatch({
      type: DELETE_START,
      payload: p.id
    });

    try {
      const response = await api.delete(`partnerships/delete/${p.id}`);
      const { data } = response;

      if (data.success) {
        toast.success('Sponsorship request canceled.');

        dispatch({
          type: DELETE_SUCCESS
        });

        if (isFunction(callback)) {
          callback();
        }
      } else {
        dispatch({
          type: DELETE_FAILURE
        });

        toast.error('Unable to complete request.');
      }
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: DELETE_FAILURE
      });
    }
  };
}

export function view(id) {
  return async dispatch => {
    dispatch({
      type: VIEW_START
    });

    try {
      let url = `partnerships/view/${id}`;
      const response = await api.get(url);
      const { data } = response;

      if (data.success) {
        dispatch({
          type: VIEW_SUCCESS,
          payload: data.data
        });
      } else {
        toast.error('Unable to view sponsorship!');
        dispatch({
          type: VIEW_FAILURE,
          payload: response
        });
      }
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: VIEW_FAILURE,
        payload: response
      });
    }
  };
}

export function acceptPartnership(p) {
  return async dispatch => {
    dispatch({
      type: ACCEPT_START
    });

    try {
      const response = await api.post(`partnerships/accept/${p.id}`);
      const { data } = response;

      if (data.success) {
        toast.success('Sponsorship request accepted.');

        dispatch({
          type: ACCEPT_SUCCESS,
          payload: data
        });
      } else {
        dispatch({
          type: ACCEPT_FAILURE
        });

        toast.error('Unable to complete request.');
      }
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: ACCEPT_FAILURE
      });
    }
  };
}

export function rejectPartnership(p, declined = false) {
  return async dispatch => {
    dispatch({
      type: REJECT_START
    });

    try {
      const response = await api.post(`partnerships/reject/${p.id}`, {
        declined: declined
      });
      const { data } = response;

      if (data.success) {
        toast.success('Sponsorship request rejected.');

        dispatch({
          type: REJECT_SUCCESS,
          payload: data
        });
      } else {
        dispatch({
          type: REJECT_FAILURE
        });

        toast.error('Unable to complete request.');
      }
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: REJECT_FAILURE
      });
    }
  };
}

export function agree(p, history) {
  return async dispatch => {
    dispatch({
      type: AGREE_START
    });

    try {
      const response = await api.post(`partnerships/agree/${p.id}`);
      const { data } = response;

      if (data.success) {
        toast.success('Terms accepted.');

        dispatch({
          type: AGREE_SUCCESS,
          payload: data
        });

        history.push('/sponsorships?type=engaged');
      } else {
        dispatch({
          type: AGREE_FAILURE
        });

        toast.error('Unable to complete request.');
      }
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: AGREE_FAILURE
      });
    }
  };
}

export function disagree(p, history) {
  return async dispatch => {
    dispatch({
      type: DISAGREE_START
    });

    try {
      const response = await api.post(`partnerships/disagree/${p.id}`);
      const { data } = response;

      if (data.success) {
        toast.success('Terms rejected.');

        dispatch({
          type: DISAGREE_SUCCESS,
          payload: data
        });

        history.push('/sponsorships?type=engaged');
      } else {
        dispatch({
          type: DISAGREE_FAILURE
        });

        toast.error('Unable to complete request.');
      }
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: DISAGREE_FAILURE
      });
    }
  };
}

export function reply(saveData, callback) {
  return async dispatch => {
    dispatch({
      type: REPLY_START
    });

    try {
      const response = await api.post('partnerships/reply', saveData);
      const { data } = response;

      if (data.success) {
        toast.success('Reply sent!');

        dispatch({
          type: REPLY_SUCCESS,
          payload: data
        });

        if (callback && isFunction(callback)) {
          callback();
        }
      } else {
        dispatch({
          type: REPLY_FAILURE
        });

        toast.error('Unable to send reply.');
      }
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: REPLY_FAILURE
      });
    }
  };
}

export function sendPayment(id) {
  return async dispatch => {
    dispatch({
      type: SEND_PAYMENT_START
    });

    try {
      const response = await api.post(`partnerships/send-payment/${id}`);
      const { data } = response;

      if (data.success) {
        toast.success('Payment sent!');

        dispatch({
          type: SEND_PAYMENT_SUCCESS,
          payload: data
        });
      } else {
        dispatch({
          type: SEND_PAYMENT_FAILURE
        });

        toast.error('Unable to send payment.');
      }
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: SEND_PAYMENT_FAILURE
      });
    }
  };
}

export function receivePayment(id) {
  return async dispatch => {
    dispatch({
      type: RCV_PAYMENT_START
    });

    try {
      const response = await api.post(`partnerships/receive-payment/${id}`);
      const { data } = response;

      if (data.success) {
        toast.success('Payment received!');

        dispatch({
          type: RCV_PAYMENT_SUCCESS,
          payload: data
        });
      } else {
        dispatch({
          type: RCV_PAYMENT_FAILURE
        });

        toast.error('Unable to receive payment.');
      }
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: RCV_PAYMENT_FAILURE
      });
    }
  };
}

export function addPost(saveData) {
  return async dispatch => {
    dispatch({
      type: ADD_POST_START
    });

    try {
      const response = await api.post('partnerships/add-post', saveData);
      const { data } = response;

      if (data.success) {
        toast.success('Post added!');

        dispatch({
          type: ADD_POST_SUCCESS,
          payload: data
        });
      } else {
        dispatch({
          type: ADD_POST_FAILURE
        });

        toast.error('Unable to add post.');
      }
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: ADD_POST_FAILURE
      });
    }
  };
}

export function markComplete(id) {
  return async dispatch => {
    dispatch({
      type: MARK_COMPLETE_START
    });

    try {
      const response = await api.post(`partnerships/complete/${id}`);
      const { data } = response;

      if (data.success) {
        toast.success('Sponsorship completed!');

        dispatch({
          type: MARK_COMPLETE_SUCCESS,
          payload: data
        });
      } else {
        dispatch({
          type: MARK_COMPLETE_FAILURE
        });

        toast.error('Unable to complete sponsorship.');
      }
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: MARK_COMPLETE_FAILURE
      });
    }
  };
}

export function reactivate(id, reason) {
  return async dispatch => {
    dispatch({
      type: REACTIVATE_START
    });

    try {
      const response = await api.post(`partnerships/reactivate/${id}`, {
        reason: reason
      });
      const { data } = response;

      if (data.success) {
        toast.success('Sponsorship reactivated!');

        dispatch({
          type: REACTIVATE_SUCCESS,
          payload: data
        });
      } else {
        dispatch({
          type: REACTIVATE_FAILURE
        });

        toast.error('Unable to reactivate sponsorship.');
      }
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: REACTIVATE_FAILURE
      });
    }
  };
}

export function fulfill(id) {
  return async dispatch => {
    dispatch({
      type: FULFILL_START
    });

    try {
      const response = await api.post(`partnerships/fulfill/${id}`);
      const { data } = response;

      if (data.success) {
        toast.success('Sponsorship fulfilled!');

        dispatch({
          type: FULFILL_SUCCESS,
          payload: data
        });
      } else {
        dispatch({
          type: FULFILL_FAILURE
        });

        toast.error('Unable to fulfill sponsorship.');
      }
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: FULFILL_FAILURE
      });
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/app/partnerships/actions.js